import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import audioIcon from '@lifesize/ux-assets/vectors/svgIcons/headset.svg';
import chevronDownIcon from '@lifesize/ux-assets/vectors/svgIcons/chevron-down.svg';
import chevronUpIcon from '@lifesize/ux-assets/vectors/svgIcons/chevron-up.svg';
import videoIcon from '@lifesize/ux-assets/vectors/svgIcons/video.svg';
import Button from 'components/Button/Button';
import AvSettingsModal from 'components/AvSettings/AvSettingsModal';
import OneTimeMeetingBuilder from 'containers/OneTimeMeetingBuilder/OneTimeMeetingBuilderContainer';
import StartCallSearchCont from 'containers/StartCallSearch/StartCallSearchContainer';
import classes from './StartCallModal.module.scss';

class StartCallModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showInstructions: false,
      showAvSettings: false,
      mounted: true
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.userTriggeredInstructions) {
      if (nextProps.manualDial) {
        this.setState({ showInstructions: true });
      }
      if (!nextProps.manualDial) {
        this.setState({ showInstructions: false });
      }
    }
  }

  componentWillUnmount() {
    this.props.clearSelectedCall();
    this.setState({
      mounted: false
    });
  }

  onToggleAvSettings = () => {
    this.setState({
      showAvSettings: !this.state.showAvSettings
    });
  };

  renderHeader = () => (
    <header>
      <h1>
        <FormattedMessage
          id="components.startCall.title.startMeeting"
          defaultMessage="Start a Meeting"
        />
      </h1>
      <h6>
        <FormattedMessage
          id="components.startCall.instructions"
          defaultMessage="Call a contact or a conference room, or join a meeting."
        />
      </h6>
    </header>
  );

  render() {
    const { contact, searchString, callOneTime } = this.props;
    const { showInstructions } = this.state;

    if (callOneTime) {
      return (
        <div className={classes.container}>
          <div
            className={classes.contentContainer}
          >
            {this.renderHeader()}
            <OneTimeMeetingBuilder />
          </div>
        </div>
      );
    }

    return (
      <div className={classes.container}>
        {this.state.showAvSettings ? (
          <AvSettingsModal
            className={classes.avSettingsContainer}
            isStartCallFlow={true}
            onToggleAvSettings={this.onToggleAvSettings}
          />
        ) : (
          <div
            className={classes.contentContainer}
          >
            {this.renderHeader()}
            <div className={classes.content}>
              {
                <StartCallSearchCont
                  contact={contact}
                  searchString={searchString}
                />
              }
            </div>
            <div className={classes.instructionContainer} datatestid={'instructionContainer'}>
              <div className={classes.toggle}>
                <button
                  type="button"
                  onClick={() => this.setState({
                    showInstructions: !showInstructions,
                    userTriggeredInstructions: true
                  })}
                  data-testid="manual-call-instructions"
                >
                  <FormattedMessage
                    id="components.startCallModal.manualCall.instructions.toggle"
                    description="Offer instructions for calling people not in your address book"
                    defaultMessage="How to call someone not in your directory"
                  />
                  <SVG src={showInstructions ? chevronUpIcon : chevronDownIcon} className={classes.indicator} />
                </button>
              </div>
              <div className={`${classes.instructions} ${showInstructions ? classes.show : ''}`}>
                <div className={classes.title}>
                  <FormattedMessage
                    id="components.startCallModal.manualCall.instructions.title"
                    description="Prompt user to follow one of the sample formats"
                    defaultMessage="Follow these sample formats:"
                  />
                </div>
                <div className={classes.details}>
                  <div>
                    <dl>
                      <dt>
                        <FormattedMessage
                          id="components.startCallModal.manualCall.instructions.format.ip"
                          description="IP address"
                          defaultMessage="IP address"
                        />
                      </dt>
                      <dd>203.0.113.0</dd>
                      <dt>
                        <FormattedMessage
                          id="components.startCallModal.manualCall.instructions.format.ipAndExt"
                          description="IP address and extension"
                          defaultMessage="IP address and extension"
                        />
                      </dt>
                      <dd>203.0.113.0##1234567</dd>
                    </dl>
                  </div>
                  <div>
                    <dl>
                      <dt>
                        <FormattedMessage
                          id="components.startCallModal.manualCall.instructions.format.video"
                          description="Video address"
                          defaultMessage="Video address"
                        />
                      </dt>
                      <dd>
                        <FormattedMessage
                          id="components.startCallModal.manualCall.instructions.example.email"
                          description="Example Email"
                          defaultMessage="name@company.com"
                        />
                      </dd>
                      <dt>
                        <FormattedMessage
                          id="components.startCallModal.manualCall.instructions.format.lifesize"
                          description="Lifesize extension"
                          defaultMessage="Lifesize extension"
                        />
                      </dt>
                      <dd>1234567</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <a tabIndex="-1" data-testid="preCallCameraAudioCheck" className={classes.avCheck} onClick={this.onToggleAvSettings} >
                <FormattedMessage
                  id="components.startCall.avCheck"
                  defaultMessage="Pre-call camera and audio check"
                />
                <SVG src={this.state.showAvSettings ? chevronUpIcon : chevronDownIcon} className={classes.indicator} />
              </a>
            </div>
          </div>
        )}
        <div className={classes.buttonBar}>
          <Button
            disabled={!Object.keys(contact).length}
            onClick={() => {
              this.setState({
                showAvSettings: false
              });
              this.props.handleVideoCall();
            }}
            dataAttrs={{ 'data-testid': 'start-video', 'data-lsqa': 'start-video' }}
          >
            <SVG src={videoIcon} data-testid="videoIcon" />
            <FormattedMessage
              id="components.startCall.video"
              defaultMessage="Start with Camera On"
            />
          </Button>
          <Button
            disabled={!Object.keys(this.props.contact).length}
            onClick={() => {
              this.setState({
                showAvSettings: false
              });
              this.props.handleAudioCall();
            }}
            dataAttrs={{ 'data-testid': 'start-audio', 'data-lsqa': 'start-audio' }}
          >
            <SVG src={audioIcon} data-testid="audioIcon" />
            <FormattedMessage
              id="components.startCall.audio"
              defaultMessage="Start with Camera Off"
            />
          </Button>
        </div>
      </div>
    );
  }
}

StartCallModal.propTypes = {
  handleVideoCall: PT.func.isRequired,
  handleAudioCall: PT.func.isRequired,
  contact: PT.object,
  manualDial: PT.bool,
  searchString: PT.string,
  selectedSources: PT.object,
  clearSelectedCall: PT.func,
  callOneTime: PT.bool,
};

export default StartCallModal;
